"use client";

import { useEffect } from "react";

import { handleBoundaryError } from "@/components/errors/handle-boundary-error";
import { MainErrorFallback } from "@/components/errors/main";

export default function AppError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    handleBoundaryError(error);
  }, [error]);

  return <MainErrorFallback />;
}
